/**
 * STC Saudi Arabia mobile number validation
 * Accepts any number starting with 05 or 9665
 * @param {string} phoneToTest - Phone number to validate
 * @returns {object} - {valid: boolean, phoneNumber: string|null}
 */
export const validateStcPhone = (phoneToTest) => {
    const key = "966";
    let phoneNumber = phoneToTest.trim();
    
    // Case 1: Full number with country code 966 starting with 5 (should be 12 digits total)
    if (phoneNumber.startsWith("9665") && phoneNumber.length == 12) {
        return { valid: true, phoneNumber: phoneNumber };
    }
    
    // Case 2: Number starts with 05 (local format) - convert to international
    if (phoneNumber.startsWith("05") && phoneNumber.length == 10) {
        return { valid: true, phoneNumber: key + phoneNumber.slice(1) }; // Remove leading 0, add 966
    }
    
    // Case 3: Number without country code starting with 5 (9 digits like 5xxxxxxxx)
    if (phoneNumber.startsWith("5") && phoneNumber.length == 9) {
        return { valid: true, phoneNumber: key + phoneNumber };
    }
    
    return { valid: false, phoneNumber: null };
}

/**
 * Mobily Saudi Arabia mobile number validation
 * Accepts any number starting with 05 or 9665
 * @param {string} phoneToTest - Phone number to validate
 * @returns {object} - {valid: boolean, phoneNumber: string|null}
 */
export const validateMobilyPhone = (phoneToTest) => {
    const key = "966";
    let phoneNumber = phoneToTest.trim();
    
    // Case 1: Full number with country code 966 starting with 5 (should be 12 digits total)
    if (phoneNumber.startsWith("9665") && phoneNumber.length == 12) {
        return { valid: true, phoneNumber: phoneNumber };
    }
    
    // Case 2: Number starts with 05 (local format) - convert to international
    if (phoneNumber.startsWith("05") && phoneNumber.length == 10) {
        return { valid: true, phoneNumber: key + phoneNumber.slice(1) }; // Remove leading 0, add 966
    }
    
    // Case 3: Number without country code starting with 5 (9 digits like 5xxxxxxxx)
    if (phoneNumber.startsWith("5") && phoneNumber.length == 9) {
        return { valid: true, phoneNumber: key + phoneNumber };
    }
    
    return { valid: false, phoneNumber: null };
}

/**
 * Combined STC and Mobily Saudi Arabia mobile number validation
 * Primary format: 05XXXXXXXX (local format starting with 05)
 * Also accepts: 966XXXXXXXXX (international format starting with 9665)
 * Also accepts: 5XXXXXXXX (9 digits starting with 5)
 * @param {string} phoneToTest - Phone number to validate
 * @returns {object} - {valid: boolean, phoneNumber: string|null, provider: string|null}
 */
export const validateSaudiPhone = (phoneToTest) => {
    const key = "966";
    let phoneNumber = phoneToTest.trim();
    
    // Case 1: Number starts with 05 (preferred local format) - 10 digits total
    if (phoneNumber.startsWith("05") && phoneNumber.length === 10) {
        return { 
            valid: true, 
            phoneNumber: key + phoneNumber.slice(1), // Remove leading 0, add 966
            provider: 'Saudi' 
        };
    }
    
    // Case 2: Number without country code starting with 5 (9 digits like 5xxxxxxxx)
    if (phoneNumber.startsWith("5") && phoneNumber.length === 9) {
        return { 
            valid: true, 
            phoneNumber: key + phoneNumber, // Add 966 country code
            provider: 'Saudi' 
        };
    }
    
    // Case 3: Full number with country code 966 starting with 5 (international format) - 12 digits total
    if (phoneNumber.startsWith("9665") && phoneNumber.length === 12) {
        return { 
            valid: true, 
            phoneNumber: phoneNumber,
            provider: 'Saudi' 
        };
    }
    
    return { valid: false, phoneNumber: null, provider: null };
}